import { Profile } from "app/helpers/globals";


export const bktachoProfile: Profile = {
    key: 'bktacho',
    domains: ['bktacho.gr'],
    theme: 'bktacho',
    apiUrl: (domain: string) => {
        return `https://api.${domain}/TachoSafe/`;
    },
    billingApiUrl: (domain: string) => {
        return `https://billing.${domain}/webProBilling`;
    },
    chartApiUrl: (domain: string) => {
        return `https://rszoft-report.${domain}/charts-generator-api/v0/`
    },
    // apiUrl: 'http://localhost:4200/TachoSafe/',
    // billingApiUrl: 'http://localhost:4200/TachoSafe/',
    // chartApiUrl: 'http://localhost:4200/TachoSafe/',
    i18nUrl: 'https://i18n.tacho5safe.com',
    i18nKey: 'tgpak_gvptiytqoe4ha4deonwdmzlonbrg23lhorsw23lbnaytg',
    disabledFeatures: [],
    topBarButtons: {
        more: true,
        help: true,
        phone: true,
        rduAdmin: true,
        rduManager: false,
        t2sUpdater: true,
        tachosafeSite: true,
        changesInStructure: true,
    },
    language: {
        fallback: 'en',
        default: 'gr',
    },
    showAds: false,
    websiteTitle: 'Tachograph analysis by BK Telematics',
    staticFiles: {
        logoColor: 'assets/profiles/bktacho/newLogoColored.svg',
        logoBlackAndWhite: 'assets/profiles/bktacho/newLogo.svg',
        favicon: 'assets/profiles/bktacho/favicon.ico',
        backgroundImage: 'assets/profiles/bktacho/bg.jpg',
    },
    footerLinks: [
        // {
        //     name: 'Mobileye Türkiye Ausis, Çarpışma Önleyici Sistemler, Araç Takip',
        //     url: 'https://www.ausis.com.tr/'
        // }
    ],
    documentLinks: {
        termsOfService: 'https://tachosafe.ro/terms-and-conditions',
        cookieNotice: 'https://tachosafe.ro/cookie-policy',
        privacyPolicy: 'https://tachosafe.ro/confidentiality-policy',
    },
    noDriverVehicleBanner: 'normal',
    disabledReports: [],
    forceShowScheduledReports: false,
};